import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import IndexSectionHeaders1 from '../components/headers/IndexSectionHeaders1';
import IndexSectionCards2 from '../components/cards/IndexSectionCards2';
import IndexSectionAbout5 from '../components/about/IndexSectionAbout5';
import IndexSectionFeatures3 from '../components/features/IndexSectionFeatures3';
import IndexSectionFooters4 from '../components/footers/IndexSectionFooters4';

const meta = {
  title: 'Aexy.io - Disney quality tools for everyone',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <IndexSectionHeaders1 />
      {/* <IndexSectionCards2 /> */}
      <IndexSectionAbout5 />
      <IndexSectionFeatures3 />
      <IndexSectionFooters4 />
    </React.Fragment>
  );
}

